// extracted by mini-css-extract-plugin
export default {"not-found-container":"notFoundPage_not-found-container__GxD-A","not-found-title":"notFoundPage_not-found-title__NKUUq","not-found-text":"notFoundPage_not-found-text__7o3JP"};